import { render, staticRenderFns } from "./Indexing.vue?vue&type=template&id=3b48bc3f&scoped=true"
import script from "./Indexing.vue?vue&type=script&lang=js"
export * from "./Indexing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b48bc3f",
  null
  
)

export default component.exports